import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  span {
    position: absolute;
    bottom: calc(100% + 12px);
    left: 0;
    transform: translateX(-70%);

    width: 160px;
    padding: 8px 5px 8px 10px !important;
    background: #003399;
    color: #fff !important;
    border-radius: 4px;
    opacity: 0;
    transition: all 0.3s;
    visibility: hidden;

    font-size: 14px;
    font-weight: 500;

    &::before {
      content: '';
      position: absolute;
      border-style: solid;
      border-color: #003399 transparent;
      border-width: 6px 6px 0 6px;
      top: 100%;
      left: 75%;
      transform: translateX(-50%);
    }
  }

  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;
